import { mapMutations } from 'vuex';

const clipboardCopyMixins = {
	methods: {
		...mapMutations(['openSnackbar']),

		copyFileNameToClipboard(filename) {
			let filenameWithoutExtension = filename
				.split('.')
				.slice(0, -1)
				.join('.');
			this.copyToClipboard(filenameWithoutExtension);
		},
		copyToClipboard(dataToCopy) {
			try {
				navigator.clipboard.writeText(dataToCopy).then(() => {
					this.openSnackbar({
						text: ` '${dataToCopy}' copied to Clipboard`,
						time: 1500,
						color: '#468647',
					});
				});
			} catch (err) {
				console.error('Failed to copy: ', err);
			}
		},
	},
};

export default clipboardCopyMixins;
